import RESTAdapter from '@ember-data/adapter/rest';
import { InvalidError } from '@ember-data/adapter/error';
import { ajax } from '@square/dashboard-utilities/utils/xhr';
import multipartFormSerialize from '@square/dashboard-data/utils/multipart-form-serialize';

// eslint-disable-next-line ember/no-classic-classes
export default RESTAdapter.extend({
  init(...args) {
    this._super(...args);
    this.useFetch = false;
  },
  namespace: '/api/v1/multiunit',
  pathForType() {
    return 'subunits';
  },
  shouldCreateViaFormData(record) {
    return this.isProfileImageDirty(record) || this.isProfileBannerImageDirty(record) || this.isMerchantImageDirty(record);
  },
  shouldSaveViaFormData(record) {
    return this.isProfileImageDirty(record) || this.isProfileBannerImageDirty(record);
  },
  isProfileImageDirty(record) {
    return record.get('merchantProfile.profileImage') instanceof File;
  },
  isProfileBannerImageDirty(record) {
    return record.get('merchantProfile.profileBannerImage') instanceof File;
  },
  isMerchantImageDirty(record) {
    return record.get('merchantProfile.merchantImages') ? record.get('merchantProfile.merchantImages').length > 0 : false;
  },
  toFormData(record) {
    const fd = new FormData();
    const payload = record.serialize();
    const nullableParts = [];
    if ('profileImage' in record.merchantProfile.changedAttributes()) {
      nullableParts.push('entity.merchant_profile.profile_image');
    }
    if ('profileBannerImage' in record.merchantProfile.changedAttributes()) {
      nullableParts.push('entity.merchant_profile.profile_banner_image');
    }
    multipartFormSerialize(payload, [], [], true, nullableParts).forEach(([key, value]) => fd.append(key, value));
    return fd;
  },
  async updateRecord(store, type, snapshot) {
    const record = snapshot.record;
    if (this.shouldSaveViaFormData(record)) {
      return this._submitRecordViaFormData(record, 'PUT');
    } else {
      const superResp = await this._super(store, type, snapshot);
      if (superResp?.entity?.token && store.peekRecord('merchant-subunit-basic', superResp.entity.token)) {
        store.pushPayload('merchant-subunit-basic', superResp.entity);
      }
      return superResp;
    }
  },
  createRecord(store, type, snapshot) {
    const record = snapshot.record;
    if (this.shouldCreateViaFormData(record)) {
      return this._submitRecordViaFormData(record, 'POST');
    } else {
      return this._super(store, type, snapshot);
    }
  },
  _buildAjaxParams(record, method) {
    const fd = this.toFormData(record);
    return {
      type: method,
      data: fd,
      processData: false,
      contentType: false
    };
  },
  // Modified combo of RESTAdapter's SaveRecord and _ajax functions,
  // altered to send using FormData, thereby allowing multipart file uploads.
  _submitRecordViaFormData(record, method) {
    const params = this._buildAjaxParams(record, method);
    const url = this.buildURL(record.constructor, record.token);
    return ajax(url, params);
  },
  queryRecord(store, type, query) {
    if (!query.token) {
      throw new Error('unit token is missing');
    }
    const suffix = 'params' in query ? `?${query.params.join('&')}` : '';
    let url = this.buildURL(type.modelName, null, null, 'query', query);
    url = `${url}/${query.token}${suffix}`;
    return this.ajax(url, 'GET');
  },
  handleResponse(status, headers, payload, requestData) {
    if (status === 200) {
      return this._super(status, headers, payload, requestData);
    } else {
      const errors = this.normalizeErrorResponse(status, headers, payload, requestData);
      errors[0].detail = payload.message;
      return new InvalidError(errors);
    }
  }
});